import { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Base64 } from 'js-base64';
import liff from "@line/liff";

import { useBindingContext } from "@/apps/@components/binding-context";

const TbGameRedirectPage = () => {
	const navigate = useNavigate();
	const { from, payload, clear } = useBindingContext();
	const [paddingClass, setPaddingClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [descriptionClass, setDescriptionClass] = useState("");
	const [imageClass, setImageClass] = useState("");
	const [buttonClass, setButtonClass] = useState("");


	useEffect(() => {
		(async () => {
			if (from === "tb-game") {
				const profile = await liff.getProfile();
				console.log("profile", profile);

				const encoded = Base64.encode(JSON.stringify(profile));;

				let redirectURL = payload.redirect;
				if (redirectURL.includes("?")) {
					redirectURL += "&userinfo=" + encoded;
				}
				else {
					redirectURL += "?userinfo=" + encoded;
				}
				console.log("redirectURL", redirectURL);
				window.location.href = redirectURL;
        return;
			}
      else {
        navigate("/profile");
        clear();
        return;
      }
		})();
	}, [])

	const goToProfilePage = () => {
		navigate("/profile");
	}

	useLayoutEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setPaddingClass("text-center px-[30px] flex flex-col items-center");
			setTitleClass("w-[165px] h-auto mt-5");
			setDescriptionClass("w-[349px] h-auto mt-5");
			setImageClass("mt-16 h-auto w-full");
			setButtonClass("border-b pb-2 border-black w-[66px] h-auto mt-8");
		} else {
			setPaddingClass("text-center px-[5vw] flex flex-col items-center");
			setTitleClass("w-[26vw] h-auto mt-[5vw]");
			setDescriptionClass("w-[55vw] h-auto mt-[4vw]");
			setImageClass("mt-16 h-auto w-full");
			setButtonClass("border-b pb-2 border-black w-[10vw] h-auto mt-[4vw]");
		}
	};


	return (
		<div className={paddingClass}>
			<img
				alt={"title"}
				className={titleClass}
				src={window.assetUrl("/images/liff/thanks-page/title.png")}
			/>
			<img
				alt={"description"}
				className={descriptionClass}
				src={window.assetUrl(
					"/images/liff/thanks-page/description.png",
				)}
			/>
			<img
				alt={"cover"}
				className={imageClass}
				src={window.assetUrl("/images/liff/thanks-page/cover.jpg")}
			/>

			<div onClick={goToProfilePage}>
				<img
					alt={"profile-button"}
					className={buttonClass}
					src={window.assetUrl(
						"/images/liff/thanks-page/profile-button.png",
					)}
				/>
			</div>
		</div>
	);
};

export default TbGameRedirectPage;
